import React, { Dispatch, useRef, useState } from 'react';
import { DebouncedFunc } from 'lodash';
import '../App.css';
import Node from './Node'
import { ItemTypes } from '../ItemTypes'
import { useDrag, useDrop } from 'react-dnd'
import type { Identifier, XYCoord } from 'dnd-core'
import { IInject, IInjectNode, IScenario } from '../interfaces';

export const NODE_CONNECTOR_COLOR = 'rgba(63,131,252,0.5)';
export const NODE_HIGHLIGHT_COLOR = '#EFEFEF';

interface InjectWrapperProps {
    id: string;
    i: number;
    index: number;
    injectComponents: IInject[];
    turn: number;
    moveInject: (dragIndex: number, hoverIndex: number) => void 
    setInjectComponents: Dispatch<any>;
    setInjectItem: Dispatch<any>;
    injectItem: IInject;
    zoomLevel: number;
    selectedScenario: IScenario;
    setNodeTurnHeight: Dispatch<any>;
    node: IInjectNode;
    nodeSaving: { injectId: string, nodeId: string, saving: boolean };
    onChangeSave: DebouncedFunc<any>;
    saveScenario: (i: IInject[]) => Promise<void>;
    setNodeTurnHeightArray: Dispatch<any>;
    nodeTurnHeightArray: any;
  }

  interface DragItem {
    index: number
    id: string
    type: string
  }

  const NodeWrapper: React.FC<InjectWrapperProps> = ({ setInjectComponents, id, injectComponents, turn, moveInject, i, index, setInjectItem, injectItem, zoomLevel, selectedScenario, saveScenario, setNodeTurnHeight, node, nodeSaving, onChangeSave, setNodeTurnHeightArray, nodeTurnHeightArray  }) => {

    const [isCOADragging, setIsCOADragging] = useState<boolean>(false)
    const [coaClicked, setCoaClicked] = useState<boolean>(true)

    const ref = useRef<HTMLDivElement>(null)
    const [{ handlerId }, drop] = useDrop<
      DragItem,
      void,
      { handlerId: Identifier | null }
    >({
      accept: ItemTypes.BOX,
      collect(monitor) {
        return {
          handlerId: monitor.getHandlerId(),
        }
      },
      hover(item: DragItem, monitor) {
        if (!ref.current) {
          return
        }

        const dragIndex = item.index
        const hoverIndex = index
  
        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
          return
        }
  
        // Determine rectangle on screen
        const hoverBoundingRect = ref.current?.getBoundingClientRect()
  
        // Get vertical middle
        const hoverMiddleY =
          (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
  
        // Determine mouse position
        const clientOffset = monitor.getClientOffset()
  
        // Get pixels to the top
        const hoverClientY = (clientOffset as XYCoord).y - hoverBoundingRect.top
  
        // Only perform the move when the mouse has crossed half of the items height
        // When dragging downwards, only move when the cursor is below 50%
        // When dragging upwards, only move when the cursor is above 50%
  
        // Dragging downwards
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
          return
        }
  
        // Dragging upwards
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
          return
        }
  
        // Time to actually perform the action
        moveInject(dragIndex, hoverIndex)
  
        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        item.index = hoverIndex
      },
    })
  
    const [{ isDragging }, drag] = useDrag({
      type: ItemTypes.INJECT,
      item: () => {
        return { id, index }
      },
      canDrag: () => {
        if (id === '1') {
          return false
        } else {
          return coaClicked
        }
      },
      collect: (monitor: any) => ({
        isDragging: monitor.isDragging()
      }),
    })

    if (isDragging) {
      //
    }
  
    drag(drop(ref))

    const [isFocused, setFocused] = useState<boolean>(false);
    const onNodeFocus = () => {
      setFocused(true);
    }
    const onNodeBlur = () => {
      setFocused(false);
      onChangeSave.flush();
    }
    const zIndex = (isCOADragging || isFocused) ? 35000 : 4000 - turn;
    const isNodeSaving = nodeSaving.saving && nodeSaving.injectId === injectItem.injectId && nodeSaving.nodeId === node.id;

    return (
      <div ref={ref} data-handler-id={handlerId} key={index} className={`node-wrapper ${node.coas.length === 0 ? 'end-node' : ''}`} style={{ 'zIndex': zIndex }}>
        <div className={`node-loading ${isNodeSaving ? 'show' : ''}`}>
          <div className={`hosting-loader hosting-loader-60`}></div>
        </div>

        <Node setInjectComponents={setInjectComponents} setInjectItem={setInjectItem} injectItem={injectItem} injectComponents={injectComponents} node={node} turn={turn} id={id} key={id} index={i} greedy={false} zoomLevel={zoomLevel} selectedScenario={selectedScenario} setNodeTurnHeight={setNodeTurnHeight} saveScenario={saveScenario} onChangeSave={onChangeSave} setIsCOADragging={setIsCOADragging} isCOADragging={isCOADragging} coaClicked={coaClicked} setCoaClicked={setCoaClicked} nodeTurnHeightArray={nodeTurnHeightArray} setNodeTurnHeightArray={setNodeTurnHeightArray} onFocus={onNodeFocus} onBlur={onNodeBlur} />

      </div>
    )
  
  }
export default NodeWrapper;